import {getEventDate} from '@stubhub/react-event-helper';

/**
 * Validates a date from an event object.
 * @param {Object} event - The event object.
 * @returns {Date|undefined} - The validated date or undefined if the date is invalid.
 */
export const validateDate = (event) => {
  const calculatedDate = getEventDate(event);
  if (calculatedDate && calculatedDate.getTime && calculatedDate.getTime()) {
    return calculatedDate;
  }
};
